// extracted by mini-css-extract-plugin
export var layoutContainer = "_47-0";
export var layoutContainerOpen = "_47-5";
export var layoutContainerResizing = "_47-1";
export var mainContent = "_47-2";
export var resizeDivider = "_47-3";
export var slidePanel = "_47-4";